import React from 'react';
import { BlobContainerList } from '../BlobContainerList';
import { BlobContainerUpload } from '../BlobContainerUpload';
import { Stack } from '../Stack';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const BlobContainerFileManager = _ref => {
  let {
    containerUrl,
    uploadLabel,
    path = '',
    onChange,
    onFilesNumberChange,
    disabled,
    maxFilesNumber,
    isScrollable,
    showThumbnail
  } = _ref;
  const [refresh, setRefresh] = React.useState(true);
  const [fileListLength, setFileListLength] = React.useState(0);
  React.useEffect(() => {
    if (!refresh) {
      setRefresh(true);
      if (onChange) {
        onChange();
      }
    }
  }, [refresh]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: refresh && /*#__PURE__*/_jsxs(Stack, {
      children: [!disabled && /*#__PURE__*/_jsx(BlobContainerUpload, {
        label: uploadLabel,
        onComplete: _files => {
          setRefresh(false);
        },
        path: path,
        containerUrl: containerUrl,
        disabled: disabled,
        maxFilesNumber: maxFilesNumber,
        filesNumber: fileListLength
      }), /*#__PURE__*/_jsx(Stack, {
        styles: isScrollable && {
          root: {
            maxHeight: 285,
            overflowY: 'auto'
          }
        } || undefined,
        children: /*#__PURE__*/_jsx(BlobContainerList, {
          path: path,
          containerUrl: containerUrl,
          disabled: disabled,
          onDelete: () => {
            setRefresh(false);
          },
          onFilesNumberChange: (length, items) => {
            if (onFilesNumberChange && length > 0) {
              onFilesNumberChange(length, items);
            }
            setFileListLength(length);
          },
          showThumbnail: showThumbnail
        })
      })]
    })
  });
};